"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createProctorTest = void 0;
const react_1 = __importStar(require("react"));
const ProctorTest_1 = require("./ProctorTest");
function createProctorTest(specifications, defaultProctorGroups) {
    const ProctorContext = react_1.createContext(defaultProctorGroups);
    const useProctorGroups = () => {
        const proctorGroups = react_1.useContext(ProctorContext);
        return react_1.useMemo(() => {
            if (defaultProctorGroups) {
                return Object.assign(Object.assign({}, defaultProctorGroups), proctorGroups);
            }
            return proctorGroups;
        }, [defaultProctorGroups, proctorGroups]);
    };
    return {
        ProctorContext: ProctorContext,
        ProctorTest: (props) => {
            var _a, _b;
            const proctorGroups = useProctorGroups();
            return (react_1.default.createElement(ProctorTest_1.ProctorTest, { testName: props.testName, specifications: specifications, 
                // we cannot guarantee this is set with the context so we let the underlying
                // component check that this value is set during runtime
                proctorGroups: (_b = (_a = props.proctorGroups) !== null && _a !== void 0 ? _a : proctorGroups) !== null && _b !== void 0 ? _b : {}, onError: props.onError, buckets: props.buckets }));
        },
        useProctorGroups
    };
}
exports.createProctorTest = createProctorTest;
